import React from 'react'
import StripeCheckout from 'react-stripe-checkout';
import marksmanLogo from '../../images/sf-logo.png'
import { environment } from '../../api'
import { subscriptionHelpers } from '../../dataHelpers';
import AppError from "../../models/AppError";
import { ErrorModal, PaymentSuccessModal } from './../ui'
import { TOKEN_STORAGE_KEY, getStorage, USER_STORAGE_KEY } from "../../dataHelpers/authenticationHelpers"
import '../../stylesheets/Invoice.css'
import { STRIPEKEY, STRIPE_HEADER_NAME, CURRENCY, STRIPE_PAY_BUTTON, STRIPE_RENEW_BUTTON } from '../../constants'

let date = new Date();

class Payment extends React.Component {
    constructor(props) {
    super(props)
    let controllerID = controllerID || ''
    this.state = {
        loading: false,
        errors: [],
        amount: 0,
        modal: false,
        backdrop: 'static',
        paymentID: null,
        transDetails: null,
        paymentAmount: 0,
        randomPaymentId: null,
        controllerID,
        refrenceId: null
    }
    this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
    this.user = (props.token || JSON.parse(getStorage().getItem(USER_STORAGE_KEY)))
    this.renewSubscriptionPlan = props.renewSubscriptionPlan
    this.toggle = this.toggle.bind(this);
    this.renewPlan = this.renewPlan.bind(this);
    this.invoicePayment = props.invoicePayment
  }

  componentWillReceiveProps(nextProps) {
      console.log("will recv next props")
      console.log(nextProps)
      this.setState({
          amount: parseFloat(nextProps.amount),
          controllerID: nextProps.controllerID
      })
   }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  onToken = (token) => {
    try {
      fetch(`${environment.API_URL}/subscription_charge/`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(token),
      }).then(response => {
        if (response.ok) {
          response.json().then(data => {
            let tokenID = data.id
            //this.chargePayment((this.state.amount * 100), tokenID)
            this.chargePayment((this.props.amount * 100), tokenID)
          });
        } else {
          console.log("Payment  failed:", response);
          this.setState({ errors: [response.error] })
        }
      })
    } catch (error) {
      let appError = new AppError("Failed to send request", error.message)
      this.setState({ errors: [appError] })
    }
  }

  async chargePayment(amount, tokenID) {
    this.setState({ loading: true })

    try {
      let chargeResponse = await subscriptionHelpers.chargeSubsPlan(this.token, amount, tokenID)
      if (!chargeResponse.error) {
        if (this.props.invoicePayment) {
          this.invoicePayment()
        }
        this.setState({
          modal: true,
          backdrop: 'static',
          paymentID: chargeResponse.id.id,
          transDetails: JSON.stringify(chargeResponse.id),
          paymentAmount: chargeResponse.id.amount,
          refrenceId: chargeResponse.id.id,
          randomPaymentId: Math.floor(1000000000 + Math.random() * 9000000000) //create 10 digit random numbers
        })
      } else {
        this.setState({ errors: [chargeResponse.error] })
      }
    } catch (error) {
      let appError = new AppError("Failed to send request", error.message)
      this.setState({ errors: [appError] })
    }
  }

  async renewPlan() {
    this.setState({ modal: false })
    try {
      this.savePaymentDetails(this.state.paymentID, this.state.transDetails, this.state.randomPaymentId)
    } catch (error) {
      console.log(error.message)
    }
  }

  async savePaymentDetails(paymentID, transDetails, randomPaymentId) {
    try {
      let paidBy = this.user.email
      //let controllerId = this.state.controllerID
      let controllerId = this.props.controllerid
      let savePaymentResponse = await subscriptionHelpers.savePayment(this.token, paymentID, transDetails, randomPaymentId, paidBy, controllerId)
      if (!savePaymentResponse.error) {
        this.renewSubscriptionPlan()
        //return
      } else {
        console.log(savePaymentResponse.error)
        this.setState({ errors: [savePaymentResponse.error] })
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  dismissError(error) {
    let errors = this.state.errors.filter((e) => e !== error)
    this.setState({ errors })
  }

  render() {
    let { errors, randomPaymentId, paymentAmount, refrenceId } = this.state
    let day = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
    let month = ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1))
    let currDate = month + '-' + day + '-' + date.getFullYear()    
    return (
      <span className="printable">
          {this.props.amount && parseFloat(this.props.amount) > 0 ?
              <h3><strong>${this.props.amount}</strong><br/></h3>
          : null}
        <StripeCheckout
          token={this.onToken}
          stripeKey={STRIPEKEY}
          name={STRIPE_HEADER_NAME} // the pop-in header title
          image={marksmanLogo} // the pop-in header image (default none)
          //amount={(this.state.amount) * 100}
          amount={(this.props.amount) * 100}
          currency={CURRENCY}
          description="SureFireAgSystem-FBAG" // the pop-in header subtitle
          label={this.props.invoice == 'yes' ? STRIPE_PAY_BUTTON : STRIPE_RENEW_BUTTON}
          
        />
        {(errors.map((appError, idx) =>
          <ErrorModal key={idx} modal={true} toggle={() => (this.dismissError(appError))} text={appError.text} title={appError.title} />
        ))}
        <PaymentSuccessModal isOpen={this.state.modal} toggle={this.toggle} backdrop={this.state.backdrop} renewSubPlan={this.renewPlan}
          randomPaymentId={randomPaymentId} paymentID={refrenceId} paymentAmount={paymentAmount} paidBy={this.user.email} currDate={currDate} />
      </span>
    )
  }
}

export default Payment


// WEBPACK FOOTER //
// ./src/components/ui/Payment.js